export default {
    setData: (state, data) => {
        state.socials = data.socials;
        state.contacts = data.contacts;
    },
};
